'use client';

import React, { useRef, useState } from 'react';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { NoteData } from '@nx-frontend/shared/types';

export function SearchInput({
  placeholder,
  // data,
  onDataFiltered,
}: {
  placeholder: string;
  // data: AllPagaData[];
  onDataFiltered?: (filteredData: NoteData[]) => void;
}) {
  const [searchValue, setSearchValue] = useState<string>('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
    // const filteredData = data.filter((item: AllPagaData) => item.itemName.toLowerCase().includes(value.toLowerCase()));
    // onDataFiltered && onDataFiltered(filteredData);
  };

  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div
      onClick={() => {
        focusInput();
      }}
      className={`!min-w-[162px] max-w-[264px] h-[36px] cursor-pointer border-[1px] border-solid border-neutral-200 rounded flex items-center ${
        searchValue ? 'focus' : ''
      }`}
    >
      <div className="flex items-center w-full h-full mx-[16px] my-[12px] gap-2 overflow-hidden rounded-[30px]">
        <Icon icon={IconsMap.SEARCH} className="text-neutral-500" />
        <input
          data-cy="search-input"
          ref={inputRef}
          className="h-full w-full outline-none text-[14px] text-neutral-500 placeholder:text-neutral-500 pr-2"
          type="text"
          id="search"
          placeholder={placeholder}
          value={searchValue}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
}
